var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table-local-v-1-widget',{attrs:{"loading":_vm.loading,"items":_vm.items,"columns":_vm.cColumns,"actions":_vm.cActions},on:{"clickView":_vm.onClickView}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }